import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { LogIn, ArrowLeft } from "lucide-react";

export const ImpersonationBanner: React.FC = () => {
  const [impersonating, setImpersonating] = useState(false);
  const [tenantEmail, setTenantEmail] = useState("");

  useEffect(() => {
    const backupToken = localStorage.getItem("adminBackupToken");
    if (backupToken) {
      setImpersonating(true);
      try {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        setTenantEmail(userData.email || "Tenant");
      } catch (_) {
        setTenantEmail("Tenant");
      }
    } else {
      setImpersonating(false);
    }
  }, []);

  const handleExitImpersonation = () => {
    const backupToken = localStorage.getItem("adminBackupToken");
    const backupUser = localStorage.getItem("adminBackupUser");

    if (backupToken && backupUser) {
      localStorage.setItem("authToken", backupToken);
      localStorage.setItem("userData", backupUser);
      localStorage.removeItem("adminBackupToken");
      localStorage.removeItem("adminBackupUser");
      window.location.href = "/admin/tenants";
    } else {
      localStorage.removeItem("adminBackupToken");
      localStorage.removeItem("adminBackupUser");
      window.location.href = "/admin/tenants";
    }
  };

  if (!impersonating) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        backgroundColor: "#b91c1c",
        color: "#ffffff",
        py: 1,
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 4px 14px rgba(185, 28, 28, 0.4)",
        flexWrap: "wrap",
        gap: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <LogIn size={20} />
        <Typography variant="body2" sx={{ fontWeight: 600, color: "#fff" }}>
          Superadmin Impersonation Active: Currently viewing store as{" "}
          <strong style={{ textDecoration: "underline" }}>{tenantEmail}</strong>
        </Typography>
      </Box>
      <Button
        variant="contained"
        size="small"
        onClick={handleExitImpersonation}
        startIcon={<ArrowLeft size={16} />}
        sx={{
          backgroundColor: "#ffffff",
          color: "#b91c1c",
          fontWeight: 700,
          textTransform: "none",
          boxShadow: 2,
          "&:hover": {
            backgroundColor: "#fef2f2",
            color: "#991b1b",
          },
        }}
      >
        Exit to Superadmin Panel
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
